import { BankRoutingScheme } from "./bankRoutingSchemes";

/**
 * Product decisions that were living in the country config while not actually being facts about a
 * country. Serving these from the API would mean a data edit silently swapping a UI component or
 * rewriting customer copy, which is the wrong lifecycle for reference data.
 *
 * TODO: both of these want to be subscription feature flags rather than a local map. The primitive
 * this was waiting on now exists — `useFeatureFlag(slug)` reads any `ff-*` flag for the operator,
 * backed by GET /v3/provider/:id/feature-flags in v2 — so it is a slug and a hook call, with no
 * new endpoint. Suggested slug for the first: `ff-qr-printer-supplier`.
 */

/**
 * Whether to offer the QR print-supplier link. This is an Australian print partnership, so it
 * changes when a supplier contract changes — not when a country's rules do.
 */
export const showPrinterSupplierButton = (countryCode?: string): boolean => (countryCode ?? "").toUpperCase() === "AU";

/**
 * Copy shown while a Stripe account is pending.
 *
 * Keyed on the bank-routing scheme rather than the country: the "AU" variant really means "this
 * deployment collects bank details separately from Stripe onboarding", which is a property of how
 * the account is set up, not of the country.
 */
export const getStripePendingMessage = (scheme?: BankRoutingScheme | string): { title: string; body: string } =>
  scheme === "bsb"
    ? {
        title: "Bank details required",
        body: "You must complete both Deposits and Debits bank details before Stripe can be fully connected. If missing, Stripe will remain Pending Details.",
      }
    : {
        title: "Stripe setup incomplete",
        body: "Please complete the Stripe onboarding process to enable payments. Stripe will remain Pending Details until all requirements are met.",
      };
